import React, { useState, useRef, useEffect } from 'react';
import { DisplayText, Popover, TextField } from '@superops/ui-design-system';
import styled from 'styled-components';
import { getTranslatedText } from '@nile/components';
import { useIntl } from 'react-intl';

// THIS COMPONENT IS USED TO RENDER
// 1. Text
// 2. Paragraph
// 3. NUMERIC
// 4. Decimal

const CustomTextField = (props) => {
  const {
    field,
    value,
    onChange,
    isDisabled,
    multiline,
    type,
    inputMode,
    maxLength,
    customTextFieldUIProps,
    customTextFieldLabel
  } = props;
  const { fieldType, label } = field;

  const intl = useIntl();

  const [currentValue, setCurrentValue] = useState(value || null);
  const currentValueByRef = React.useRef(null);
  currentValueByRef.current = currentValue;

  const updateValue = React.useCallback((val) => {
    setCurrentValue(val);
    if (onChange && typeof onChange === 'function') {
      onChange(field, val);
    }
  });

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  const labelSize = customTextFieldUIProps?.labelSize || 'extraLarge';
  const labelWeight = customTextFieldUIProps?.labelWeight || 'Medium';
  const labelVariant = customTextFieldUIProps?.labelVariant || 'default';
  const inputVariant = customTextFieldUIProps?.inputVariant || 'outline';
  const bgTransparent = customTextFieldUIProps?.bgTransparent || false;
  const CustomTextFieldLabel = customTextFieldLabel || null;

  return (
    <>
      <div className="fields-wrapper" key={label}>
        {CustomTextFieldLabel ? (
          <CustomTextFieldLabel label={label} />
        ) : (
          <DisplayText
            size={labelSize}
            weight={labelWeight}
            className="label"
            variant={labelVariant}
          >
            {label}
          </DisplayText>
        )}
        <div className="custom-field-input text-field">
          <TextField
            onChange={updateValue}
            value={currentValueByRef.current}
            placeholder={getTranslatedText(
              intl,
              'common.placeholder.enterValue'
            )}
            disabled={isDisabled}
            multiline={multiline}
            type={type || 'text'}
            maxLength={maxLength}
            inputMode={inputMode}
            key={label}
            variant={inputVariant}
            bgTransparent={bgTransparent}
          />
        </div>
      </div>
    </>
  );
};

export default React.memo(CustomTextField);
